<template>
  <div class="content-container">
    <div class="test-bg" v-if="!showTableList.length">
      <img src="../images/no_data.png" alt="">
      <span> 暂无数据～</span>
    </div>
    <div v-else class="finsh-list">
          <el-table
      :data="showTableList"
      style="width: 100%"
      class="warning-row"
      >
      <el-table-column
        prop="evaluate_name"
        label="名称"
      >
        <template slot-scope="scope">
          <div style="color: #1989FA;">
            {{scope.row.evaluate_name}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="test_name"
        label="测试内容"
        >
      </el-table-column>
      <el-table-column
        label="掌握率"
        prop="avg_ability"
        align="center"
        width="100"
        sortable
        >
        <template slot-scope="scope">
            <div
          v-if="scope.row.avg_ability*100>=40&&scope.row.avg_ability*100<70" style="color:#F99830">
              {{Math.round(scope.row.avg_ability*100)}}%
            </div>
            <div v-else-if="scope.row.avg_ability*100>=70" style="color:#67C23A">
            {{Math.round(scope.row.avg_ability*100)}}%
            </div>
            <div v-else style="color:#F56C6C">
            {{Math.round(scope.row.avg_ability*100)}}%
            </div>
          </template>
      </el-table-column>
      <el-table-column
        prop="created"
        label="老师发布时间"
        width="200"
        align="center"
        sortable>
      </el-table-column>
      <el-table-column
        prop="end_time"
        label="测试完成时间"
        width="200"
        align="center"
        sortable>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="90"
        >
        <template slot-scope="scope">
            <a @click="goReport(scope.row.tsid)" class="go-report">查看报告</a>
          </template>
      </el-table-column>
    </el-table>
    <div class="prepare-pagination" v-if="showTableList.length">
      <el-pagination
       background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"

      :page-sizes="[10,20,50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
  </div>
    </div>
  </div>
</template>

<script>
import { openTab } from '@/utils';

export default {
  name: 'FinishedContent',
  data() {
    return {
      currentPage: 1,
    };
  },
  props: {
    activeId: {
      default: '0',
      type: String,
    },
    finishedList: {
      type: Array,
      default: () => [],
    },
    pageSize: {
      default: 10,
      type: Number,
    },
    total: {
      default: 0,
      type: Number,
    },
  },
  methods: {
    goReport(id) {
      const isProduction = !window.location.host.includes('test');
      const schoolId = localStorage.getItem('school_id') || '';

      // 区分线上和测试环境
      const host = isProduction
        ? 'https://jzjx.classba.cn'
        : 'https://jzjx-test.classba.cn'; // 测试环境
      // const host = 'https://jzjx-test.classba.cn'; // 开发环境
      const url = `${host}/dl-web/question/report?id=${id}&schoolId=${schoolId}`;
      openTab(url);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.pageSize = val;
      this.$emit('changePageSize', val);
      // localStorage.setItem('pageSize', val);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.$emit('changeCurrent', val);
      localStorage.setItem('currentPage', val);
    },
  },
  computed: {
    showTableList() {
      if (this.activeId === '0') {
        return this.finishedList;
      }
      return this.finishedList.filter((item) => item.subject_id.toString() === this.activeId);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-container{
  // display: flex;
  // justify-content: space-between;
  // flex-wrap: wrap;
  font-family: PingFangSC-Medium, PingFang SC;
  .go-report{
  font-weight: 500;
  color: #1989FA;
  cursor: pointer;
  .finsh-list{
    width: 100%;
  }
}
.test-bg{
    margin: 86px auto;
    position: relative;
    img{
      display: block;
    margin: 0 auto;
    }
    span{
      position: absolute;
      left: 50%;
      transform: translate(-50%,12px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.6);
    }
}
}

::v-deep {
  .el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
}
.prepare-pagination{
  height: 103px;
  display: flex;
  align-items: center;
}
/deep/.el-table{
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #606266;
    .el-table__header th {
    background-color: #F0F2F5;;
    }
  }
  /deep/ .el-pagination {
    display: flex;
    // position: absolute;
    width: calc(100% - 64px);
    // bottom: 30px;
    // left: 32px;
    .btn-prev {
      margin-left: auto !important;
    }
  }
</style>
